import { render, staticRenderFns } from "./ExwarehouseDetail.vue?vue&type=template&id=22ba804c&scoped=true&"
import script from "./ExwarehouseDetail.vue?vue&type=script&lang=ts&"
export * from "./ExwarehouseDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba804c",
  null
  
)

export default component.exports